import React, { useState, useEffect, Fragment, useContext } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import AddSellerForm from './AddSellerForm';

const CourseSeller = (props) => {

	const authContext = useContext(AuthContext);
	const { getSchoolID, schoolID } = authContext;

	useEffect(() => {
		getSchoolID();
    }, []);

	return (

		<AddSellerForm 
			SchoolStorageID={schoolID}
			{...props}
		/>

	);
};

export default CourseSeller;
